import { FC } from "react";
import { CustomCellRendererProps } from "ag-grid-react";
import { ProcessedHistoryData } from "@/store/budgets/selectors/details-drawer/budgetDetailsHistoryProcessedDataSelector";
import { BudgetNoCollectedDataChip } from "@/components/pages/budgets-and-alerts/components/grids/budgets/components/cells/BudgetNoCollectedDataChip";
import { TrendChip } from "@/components/common/chips/TrendChip";

export const BudgetDetailsHistoryVariancePercentBasedCell: FC<
  CustomCellRendererProps<ProcessedHistoryData>
> = ({ data }) => {
  if (typeof data?.budgetVariancePercentage === "string") {
    return <BudgetNoCollectedDataChip />;
  }

  return <TrendChip hideIcon value={data?.budgetVariancePercentage} />;
};
